<template>
  <Modal :id="'cpm-add-invoice-modal'" :loadingFlag="loading || formLoading" @cancelled="onCancel">
    <template slot="header">{{$t('search')}}</template>

    <template slot="body">
      <div class="form-group">
        <!-- {{advancedSearchData.releaseStatusesTV}} -->
        <Dropdown
          :options="advancedSearchData.labelsTV || []"
          :id="'label_id'"
          class="m2"
          :selected="
            advancedSearchData.labelsTV.find((e) => e.value == label_id)
          "
          :placeholder="$t('labels')"
          @selectedChange="(e) => onDropdownChange('label_id', e)"
          box
          deselect
          :listHeight="250"
        ></Dropdown>
        <TextField
          class="m1"
          :id="'artist'"
          v-bind="textFieldConfig"
          :value="artist"
          :placeholder="$t('artist_name')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'title'"
          :value="title"
          v-bind="textFieldConfig"
          :placeholder="$t('Title')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <Dropdown
          :options="advancedSearchData.releaseTypeTV || []"
          :id="'currency'"
          class="m2"
          :selected="
            advancedSearchData.releaseTypeTV.find(
              (e) => e.value == release_type
            )
          "
          :placeholder="$t('releases_type')"
          @selectedChange="(e) => onDropdownChange('release_type', e)"
          box
          :listHeight="250"
        ></Dropdown>
        <Dropdown
          :options="advancedSearchData.releaseStatusesTV || []"
          :id="'currency'"
          class="m2"
          :selected="
            advancedSearchData.releaseStatusesTV.find(
              (e) => e.value == release_status
            )
          "
          :placeholder="$t('releases_status')"
          @selectedChange="(e) => onDropdownChange('release_status', e)"
          box
          :listHeight="250"
        ></Dropdown>
        <!-- <TextField
          :id="'start_date'"
          v-model="start_date"
          class="m1"
          :placeholder="$t('Release Date')"
          :type="'date'"
          @valuechanged="onTextFieldValueChange"
           
        ></TextField> -->
        <div class="ut-flex">
          <TextField
            type="date"
            id="start_date"
            style="
              margin-left: 0px !important;
              margin-right: 5px !important;
              flex: 1;
            "
            class="m1"
            :placeholder="`${$t('release_date')} ${$t('from')}`"
            :value="start_date"
            :showImmediate="true"
            autocomplete="off"
            @valuechanged="onDateChange"
          />
          <TextField
            type="date"
            id="end_date"
            style="
              margin-right: 0px !important;
              margin-left: 5px !important;
              flex: 1;
            "
            class="m1"
            :placeholder="`${$t('release_date')} ${$t('to')}`"
            :value="end_date"
            :showImmediate="true"
            autocomplete="off"
            @valuechanged="onDateChange"
          />
        </div>
        <TextField
          :id="'identifier'"
          v-bind="textFieldConfig"
          class="m1"
          :placeholder="$t('identifier')"
          :value="identifier"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        class="dt-button s6 v1"
        :disabled="loading"
        :class="{
          disabled: loading,
        }"
        @click.stop="searchClick"
      >
        {{$t('search')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { ensureStringObjectFromKeys } from "../../../../utility/fp";
import { releaseListAdvancedSearchConfig } from "./releases-list.vue";

export default {
  components: {
    Modal,
  },
  props: {
    loading: {
      type: Boolean,
    },
    advancedSearchData: {
      type: Object,
    },
    initSearchFilter: {
      required: true,
      type: Object,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      artist: "",
      title: "",
      start_date: "",
      end_date: "",
      identifier: "",
      release_status: null,
      label_id: null,
      release_type: null,
      formLoading: false,

      invoiceProject: null,
      currency: null,
    };
  },
  mounted: function () {
    console.log("WERE", this.labels, this.labelsTV);
  },
  watch: {
    initSearchFilter: {
      immediate: true,
      handler: function (to, from) {
        if (!to) {
          return;
        }

        releaseListAdvancedSearchConfig.advancedSearchConfigKeys.map((key) => {
          this[key] = to[key];
        });
        releaseListAdvancedSearchConfig.booleanSearchKeys.map((key) => {
          this[key] = to[key];
        });
      },
    },
  },
  computed: {
    selectedGroups: function () {
      return this.contactType === "person"
        ? this.person.groups
        : this.company.groups;
    },
    isFormValid: function () {
      return this.invoiceProject && this.currency;
    },
    labelsTV: function () {
      return this.advancedSearchData.labelsTV;
    },
    releaseStatusesTV: function () {
      return this.advancedSearchData.releaseStatusesTV;
    },
    releaseTypeTV: function () {
      return this.advancedSearchData.releaseTypeTV;
    },
    releaseEntry: function () {
      return {
        release_artist: this.artist,
        release_title: this.title,
        label_id: this.label_id,
        identifier: this.identifier,
        start_date: this.start_date,
        end_date: this.end_date,
        label_status_id: this.release_status,
      };
    },

    searchConfigStringKeys() {
      return [
        "artist",
        "title",
        "start_date",
        "end_date",
        "identifier",
        "release_status",
        "label_id",
        "release_type",
      ];
    },
    searchFilter: function () {
      const no_filter_selected =
        releaseListAdvancedSearchConfig.advancedSearchConfigKeys.every(
          (e) => !this[e]
        );

      return {
        ...ensureStringObjectFromKeys(this, this.searchConfigStringKeys),
        no_filter_selected,

        // barcode_catalog_error: this.barcode_catalog_error
        //   ? 1
        //   : 0,
      };
    },
  },
  methods: {
    onDateChange: function (name, value) {
      console.log(name, value);
      this[name] = value;
    },
    onTextFieldValueChange: function (key, value) {
      this[key] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    searchClick: async function (e) {
      this.formLoading = true;
      this.$emit("search", this.searchFilter);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
      // if(name=='status'){
      //   this.release_status=value.value;
      //     console.log("EEEEEEEEEE",name, value);
      // }
      // else if(name=='label'){
      //   this.label_id=value.value;
      //    console.log("EEEEEEEEEE",name, value,this.release_status,this.label_id);
      // }
      // else{
      //   this.release_type=value.value
      // }
      // this[name] = value;
    },

    //MARK: Methods
  },
};

const createPerson = ({
  firstName = "",
  lastName = "",
  email = "",
  phone = "",
  group = [],
} = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    group,
  };
};

const createCompany = ({
  companyName = "",
  city = "",
  country = "",
  group = [],
} = {}) => {
  return {
    companyName,
    city,
    country,
    group,
  };
};
</script>

<style lang="scss">
.cpm-add-invoice-modal {
}
</style>